import {Component} from '@angular/core';
import {
  AlertController,
  Events,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ViewController
} from 'ionic-angular';
import {ProfileAccountDetailsPage} from "../profile-account-details/profile-account-details";
import {ProfilePasswordPage} from "../profile-password/profile-password";
import {ProfileLoginPage} from "../profile-login/profile-login";
import {LobbyPage} from "../lobby/lobby";
import {LobbyDisplayPage} from "../lobby-display/lobby-display";

import {HttpClient} from '@angular/common/http';
import {Camera, CameraOptions} from '@ionic-native/camera';
import {AppVersion} from "@ionic-native/app-version";
import {PaymentsPage} from "../payments/payments";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";
import {StaffDashboardPage} from "../staff-dashboard/staff-dashboard";
import {LoyaltyRewardsPage} from "../loyalty-rewards/loyalty-rewards";
import {TermsConditionsServiceProvider} from "../../providers/terms-conditions-service/terms-conditions-service";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {UrlServiceProvider} from "../../providers/url-service/url-service";

@Component({
    selector: 'terms-page',
    templateUrl: 'terms.html'
})
export class TermsPage {

    errors: {};
    loading: boolean = true;
    documents: any;

    constructor(
      public navCtrl: NavController,
      public termsConditions: TermsConditionsServiceProvider,
      private urlService: UrlServiceProvider
    ) {
      this.getTermsConditions();
    }

    getTermsConditions() {
      return this.termsConditions.allDocuments().then((response)=>{
        this.documents = response;
        this.loading = false;
      }).catch(()=>{
        this.loading = false;
      });
    }

}



// WEBPACK FOOTER //
// ./src/pages/terms/terms.ts